import { Component, Input } from "@angular/core";

@Component({
  selector: "ds-input",
  templateUrl: "./ds-input.component.html",
  styleUrls: ["./ds-input.component.scss"],
})
export class DsInputComponent {
  @Input() error: boolean = false;

  constructor() {}
}
